const appBar = {
  defaultProps: {
    color: "transparent" as const,
  },

  styleOverrides: {
    root: {
      boxShadow: "none",
    },
  },
};

export default appBar;
